import ROUTE_PATHS from '@/consts/routePaths';

import routerService from './routerService';

const forwardToBadgesPage = () => routerService.forwardTo(ROUTE_PATHS.BADGES);

const replaceToBadgesPage = () => routerService.replace(ROUTE_PATHS.BADGES);

const forwardToInProgressPage = () => routerService.forwardTo(ROUTE_PATHS.IN_PROGRESS);

const goBack = () => routerService.goBack();

export default {forwardToBadgesPage, replaceToBadgesPage, forwardToInProgressPage, goBack};
